/** Dialog wrapper for creating an appointment booking link. */

import type { AppointmentTypeId, ClinicId } from '@snootsvet/shared'

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/frontend/components/ui/dialog'
import { AppointmentLinkForm } from '@/frontend/features/appointments/appointment-link.form'

interface BookAppointmentDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  defaultClinicId?: ClinicId
  defaultAppointmentTypeId?: AppointmentTypeId
  /** Pre-select a patient when opening from a patient context. */
  defaultPatientId?: string
  /** Optional label shown after the title (e.g. patient name). */
  subtitle?: string
  /** Called with the booking URL on success. Defaults to closing the dialog. */
  onSuccess?: (url: string) => void
}

export function BookAppointmentDialog({
  open,
  onOpenChange,
  defaultClinicId,
  defaultAppointmentTypeId,
  defaultPatientId,
  subtitle,
  onSuccess,
}: BookAppointmentDialogProps) {
  // Outside-click dismissal is disabled to avoid losing entered appointment details.
  return (
    <Dialog open={open} onOpenChange={onOpenChange} disablePointerDismissal>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {subtitle ? `Book Appointment — ${subtitle}` : 'Create Appointment Link'}
          </DialogTitle>
        </DialogHeader>
        <AppointmentLinkForm
          defaultClinicId={defaultClinicId}
          defaultAppointmentTypeId={defaultAppointmentTypeId}
          defaultPatientId={defaultPatientId}
          onSuccess={onSuccess}
        />
      </DialogContent>
    </Dialog>
  )
}
